// 彈出選單共用的關閉規則（SPEC #org-tree-ui 左樹同步驗收；第二輪 B2-03）：Esc、點選單外面都關；deps 變了（例：切範圍）也關。
import { useEffect, type RefObject } from 'react';

export function useDismiss(open: boolean, close: () => void, ref: RefObject<HTMLElement | null>, deps: unknown[] = []): void {
  useEffect(() => {
    if (!open) return;
    const off = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) close();
    };
    const esc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    document.addEventListener('mousedown', off);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', off);
      document.removeEventListener('keydown', esc);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  useEffect(() => {
    if (open) close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

/** 當彈出選單用的 <details>（例：設備清單的「欄位」）：Esc、點外面收起來（全站選單同一套規則，第二輪 B2-03）。 */
export function useDetailsDismiss(ref: RefObject<HTMLDetailsElement | null>): void {
  useEffect(() => {
    const off = (e: MouseEvent) => {
      const el = ref.current;
      if (el?.open && !el.contains(e.target as Node)) el.open = false;
    };
    const esc = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && ref.current?.open) ref.current.open = false;
    };
    document.addEventListener('mousedown', off);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', off);
      document.removeEventListener('keydown', esc);
    };
  }, [ref]);
}
